export default __webpack_public_path__ + "static/media/Junaid.a6a99b48.png";